import React, { useState } from 'react';
import WrapperImage from '@components/image/WrapperImage.tsx';
import FavoritesIcon from '@features/favouries/FavoritesIcon.tsx';
import { IconWrapper } from '@components/icons/IconWrapper.tsx';

interface ProductImageProps {
  imageUrls: string[];
  tags: string[];
  isFavorite: boolean;
  onFavoriteToggle: () => void;
  favUpdating: boolean;
  grayscale?: boolean;
  badge?: React.ReactNode;
}

const ProductImage: React.FC<ProductImageProps> = ({ imageUrls, isFavorite, onFavoriteToggle, favUpdating, grayscale, badge }) => {
  const [activeImage, setActiveImage] = useState<string | null>();

  return (
    <div className={`w-full md:w-auto flex flex-col justify-start items-center md:items-start ${grayscale ? 'grayscale' : ''}`}>
      {/* Tagy a oblíbené */}
      <div className="w-full flex justify-between items-center mb-4">
        <div className="flex justify-start items-start gap-2">
          {badge}
        </div>
        <IconWrapper className={'h-12 w-12 flex item-center justify-center cursor-pointer'}>
          <FavoritesIcon isFavorite={isFavorite} onFavoriteClick={onFavoriteToggle} favoriteLoading={favUpdating} className={'h-[32px] w-[32px]'} />
        </IconWrapper>
      </div>
      {/* Pás náhledů vlevo */}
      <div className="w-full flex justify-end gap-2">
        <ul className="shrink-0 w-20 flex flex-col items-center justify-center gap-2 p-2 z-20">
          {imageUrls.map((url, i) => (
            <li
              key={i}
              className="w-12 h-12 flex items-center justify-center p-1 rounded outline outline-1 outline-gray-200 bg-white cursor-pointer"
              onClick={() => setActiveImage(url)}
            >
              <WrapperImage src={url} /*width="46" height="46"*/ alt={`Náhled ${i + 1}`} className="object-cover" />
            </li>
          ))}
        </ul>

        {/* Hlavní obrázek */}
        <div className="flex-1 flex items-center justify-center" onClick={() => setActiveImage(imageUrls[0])}>
          <div className="aspect-square w-full max-w-[266px] cursor-pointer">
            <WrapperImage
              src={imageUrls[0]}
              /*width="800" height="800"*/
              alt="Produkt"
              className="w-full h-full object-contain"
            />
          </div>
        </div>

        {/* Modal / lightbox */}
        {activeImage && (
          <div className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50" onClick={() => setActiveImage(null)}>
            <button className="absolute top-4 right-4 text-white text-3xl" onClick={() => setActiveImage(null)}>
              ✕
            </button>
            <WrapperImage
              src={activeImage}
              /*width="1600" height="1600"*/ // tady si dej větší velikost pro fullscreen
              alt="Zvětšený obrázek"
              className="max-w-[90%] max-h-[90%] object-contain"
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default ProductImage;
